import WalletWorker from "../worker/wallet.worker?worker";

const runWorker = (count: number): Promise<any[]> => {
  return new Promise((resolve, reject) => {
    const worker = new WalletWorker();

    worker.postMessage({ count });

    worker.onmessage = (e) => {
      resolve(e.data);
      worker.terminate();
    };

    worker.onerror = (err) => {
      console.error("worker error:", err);
      reject(err);
      worker.terminate();
    };
  });
};
export const getWalletList = async (count: number = 1) => {
  const cpuCount = navigator.hardwareConcurrency || 4;

  // 分成多个线程
  const perWorker = Math.ceil(count / cpuCount);

 const tasks = Array.from({ length: cpuCount })
  .map((_, i) => {
    const start = i * perWorker;
    const end = Math.min(start + perWorker, count);

    if (start >= count) return null;

    return runWorker(end - start);
  })
  .filter(Boolean);


  const results = await Promise.all(tasks);

  return results.flat();
};
